import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  emptyText: {
    color: theme.palette.text.disabled,
    fontSize: 13,
  },
}))

export default useStyles
